import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { DEFAULT_PAGINATION_SIZE } from '../../../utils/utils';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import { useTranslations } from '../../Translations/TranslationsProvider';

interface LoadMoreButtonProps {
    currentPage: number;
    handleLoadMore: () => void;
    isLoading: boolean;
    totalResults: number;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
    currentPage,
    handleLoadMore,
    isLoading,
    totalResults,
}) => {
    const { translations } = useTranslations();

    return (
        <Grid item xs={12} textAlign="center">
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                (currentPage - 1) * DEFAULT_PAGINATION_SIZE < totalResults && (
                    <Button variant="contained" onClick={handleLoadMore}>
                        {translations.GLOBAL_LOAD_MORE_BUTTON}
                    </Button>
                )
            )}
        </Grid>
    );
};
